// 请求地址
export namespace URL {
    export const BASE_URL = "/api";
    // export const BASE_URL = "https://iruptcy.com/api";
    // export const BASE_URL = "http://192.168.101.17:5000";

    export const SEND_VERIFY_CODE = '/parent/Common/sms_send';

    export const LOGIN = '/parent/Login/logon';
    export const REGISTER = '/parent/Login/creditor_user_info';
    export const SET_PASSWORD = '/parent/Login/ret_password';
    export const PLATFORM = "/parent/Login/platform";
    export const loginCaptcha = "/parent/Login/captcha";

    export const APPLY_ACCOUNT = "/manager/plzLawfirmApply/apply";

    export const HOME_INFO = "/manager/plzReliefHome/list";
    export const BANKRUPTCY_LIST = "/manager/plzReliefHome/bankruptcy/list";
    export const DILEMMA_LIST = "/manager/plzReliefHome/dilemma/list";
    export const ALLOCATION_LIST = "/manager/plzReliefHome/allocation/list";
    export const DEMAND_LIST = "/manager/plzReliefHome/demand/list";
    export const INVESTOR_LIST = "/manager/plzReliefHome/investor/list";

    export const INVESTOR_APPLY = "/manager/plzReliefInvestor/apply?ok=csn";
    export const ENTERPRISE_APPLY = "/manager/plzReliefEnterprise/apply";
}

//全局声明
interface URL {
    //基地址
    readonly BASE_URL: string;

    //杂项
    readonly SEND_VERIFY_CODE: string;              //发送验证码

    //账号
    readonly LOGIN: string;                         //账号登录
    readonly REGISTER: string;                      //账号注册
    readonly SET_PASSWORD: string;                  //设置密码
    readonly PLATFORM: string;					    //获取平台号
    readonly loginCaptcha: string;					//获取验证码
    readonly APPLY_ACCOUNT:string;                  //申请试用账号

    //纾困首页数据
    readonly HOME_INFO:string;                      //首页数据
    readonly BANKRUPTCY_LIST:string;                //破产项目列表
    readonly DILEMMA_LIST:string;                   //纾困项目列表
    readonly ALLOCATION_LIST:string;                //配资项目列表
    readonly DEMAND_LIST:string;                    //需求列表
    readonly INVESTOR_LIST:string;                   //投资人库列表
    readonly INVESTOR_APPLY:string;                 //投资人认证
    readonly ENTERPRISE_APPLY:string;              //企业认证

}

declare module "vue/types/vue" {
    interface Vue {
        $URL: URL
    }
}
